import { Reveal } from "@/components/Reveal";

const words = ["LOVE.", "MOTHERHOOD.", "PLEASURE.", "FREEDOM.", "CREATION.", "WEALTH.", "ADVENTURE.", "PRESENCE."];

const imgs = [
  { src: "/assets/life-bus.jpg", alt: "The Love Bus — freedom and adventure" },
  { src: "/assets/dasha-dreamlife.jpg", alt: "Dasha at home — the life the vision built" },
  { src: "/assets/life-events.jpg", alt: "Dasha creating — books and stages" },
];

export const DimensionsSection = () => (
  <section data-testid="dimensions-section" className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
    <div className="flex flex-wrap items-end justify-center gap-3 sm:gap-5" data-testid="dimensions-words">
      {words.map((w, i) => (
        <Reveal key={w} delay={Math.min(i * 0.04, 0.3)}>
          <span className={`font-serif italic leading-none ${i % 2 ? "text-lime" : "text-cream"} text-3xl sm:text-5xl lg:text-6xl`}>
            {w}
          </span>
        </Reveal>
      ))}
    </div>

    <div className="mt-12 grid grid-cols-3 gap-3 sm:gap-6">
      {imgs.map((im, i) => (
        <Reveal key={im.src} delay={i * 0.08} className={i === 1 ? "-translate-y-4 sm:-translate-y-8" : ""}>
          <div className="overflow-hidden border border-white/10 shadow-[0_25px_50px_rgba(0,0,0,0.5)]">
            <img
              src={im.src}
              alt={im.alt}
              loading="lazy"
              data-testid={`dimensions-${i + 1}`}
              className="aspect-[3/4] w-full object-cover transition-transform duration-700 hover:scale-[1.04]"
            />
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal className="mt-16 text-center">
      <p className="text-2xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
        YOUR VISION GETS TO INCLUDE
        <br />
        <span className="font-serif italic font-medium text-lime">ALL OF YOU.</span>
      </p>
    </Reveal>
  </section>
);
